<template>
  <div class="progress">
    <div class="active" :style="{ width: progressRatio }"></div>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();
const progressRatio = computed(() => store.getters["survey/progressRatio"]);
</script>
<style lang="scss" scoped>
@import "@/assets/scss/dimen.scss";
.progress {
  position: relative;
  width: 100%;
  height: 15px;
  background: #eee;
  border-radius: 8px;
  margin-top: 15px;
  transition: all 0.4s;
  .active {
    position: absolute;
    left: 0;
    top: 0;
    background: $btnColor;
    border-radius: 8px;
    height: 100%;
    width: 0;
    @media (orientation: landscape) {
      border-radius: 10px;
    }
  }
}
</style>
